import styled from 'styled-components';
import { media } from '@belong/themes';

export const LinkGroupContainer = styled.div`
  margin-bottom: 4.8rem;
  ${media('xl')`
    margin-bottom: 7.2rem;
  `}
`;
